import React from "react";
import FreefieldCategory from "./FreefieldCategory";
import { type FFPermissionMap } from "./PermissionMap";

interface Props {
  categories: server.dto.FreeFieldCategorySmall[]
  permissions: FFPermissionMap
  onPermissionsChange: (permissions: FFPermissionMap) => void
  profileId: number
  environment: server.dto.Environments
}

const FreefieldCategories = (props: Props) => {
  const onPermissionChange = (ffIds: number[], newValue: server.dto.FreeFieldPermissionLevels) => {
    const newPerms = ffIds.reduce((acc, curr) => ({
      ...acc,
      [curr]: newValue
    }), { ...props.permissions });

    window.CoreApi.FreeFieldProfile.SetLevelForFreeFields({
      freeFieldProfileId: props.profileId,
      freeFieldDefinitionIds: ffIds,
      level: newValue
    });

    props.onPermissionsChange(newPerms);
  };

  return <div className="flex-column gap-larger">
    {props.categories.map((ffCat, idx) => (
      <FreefieldCategory
        key={idx}
        category={ffCat}
        permissions={props.permissions}
        onPermissionChange={onPermissionChange}
        environment={props.environment}
      />
    ))}
  </div>;
};

export default FreefieldCategories;